import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as uiStrings from '../../uiStrings';
import MarkerIconStyleProvider from '../../providers/MarkerIconStyleProvider';
import { configSelect2 } from '../../providers/SearchConfigProvider';
import urls from '../../urls';
import $ from 'jquery';

class SearchButton extends Component {
	constructor() {
		super();
		this.nextResultId = 0;
	}

	componentDidMount() {
		this.init();
		this.setupEventListeners();
	}

	init() {
		configSelect2('js-search-select2');
	}

	firstGreaterItemIndex(items, name) {
		let before = null;

		for (let i = 0; i < items.length; i++) {
			if (items[i].querySelector(".select_result-name").textContent.localeCompare(name) > 0) {
				before = items[i];
				break;
			}
		}

		return before;
	}

	isDuplicate(KOD_OBEC, KOD_COB, items) {
		for (let i = 0; i < items.length; i++) {
			const properties = JSON.parse(items[i].dataset.feature).properties;

			if (properties.KOD_OBEC == KOD_OBEC && properties.KOD_COB == KOD_COB) {
				return true;
			}
		}

		return false;
	}

	addSearchResult(feature, flyTo) {
		const id = `search-result-${this.nextResultId}`;
		let name = feature.properties.NAZ_OBEC;

		if (this.isDuplicate(feature.properties.KOD_OBEC, feature.properties.KOD_COB, this.refs["search-results"].children)) {
			return;
		}

		if (feature.properties.NAZ_COB != "") {
			name = feature.properties.NAZ_COB + ", " + name;
		}

		this.dispatchCustomEvent(eventNames.SEARCH_SELECTED, document, true, {
			id: id,
			data: feature,
			flyTo: flyTo,
		});

		const color = MarkerIconStyleProvider.getColor(id);

		const resultElem = document.createElement("div");
		resultElem.id = id;
		resultElem.dataset.feature = JSON.stringify(feature);
		resultElem.innerHTML = `
        <span>
            <span class="select_result-name"></span><br>
            <span class="select_result-okres"></span>
        </span>
        <button ref="delete-button" class="layerPanel__dialect-picker-button"><i class="fas fa-times"></i></button>
        <span ref="icon" class="layerPanel__marker-icon js-marker-icon-color" style="color: ${color};"><i class="fas fa-map-marker-alt"></i></span>`;

		this.refs["search-results"].insertBefore(
			resultElem,
			this.firstGreaterItemIndex(this.refs["search-results"].children, name)
		);

		resultElem.querySelector('.select_result-name').textContent = name;
		resultElem.querySelector('.select_result-okres').textContent = "okres " + feature.properties.NAZ_OKRES;

		if (feature.properties.cja_id != "") {
			const span = resultElem.querySelector("span");
			span.appendChild(document.createElement("br"));

			const cjaElem = document.createElement("span");
			cjaElem.classList.add("select_result-okres");
			cjaElem.textContent = "ASJ: " + feature.properties.cja_id + ", " + feature.properties.cja_nazev;
			span.appendChild(cjaElem);
		}

		const removeButton = resultElem.querySelector('[ref="delete-button"]');
		removeButton.addEventListener("click", () => {
			this.dispatchCustomEvent(eventNames.SEARCH_REMOVED, document, true, {
				id: id,
				data: feature,
			});

			removeButton.parentElement.remove();

			if (this.refs["search-results"].childElementCount == 0) {
				this.refs["with-bounds"].classList.add("u-hidden");
			}
		});

		const icon = resultElem.querySelector('[ref="icon"]');
		icon.addEventListener("click", () => {
			this.dispatchCustomEvent(eventNames.OPEN_MODAL, document, false, { contentType: 'color-picker', contentKey: id});
		});

		this.refs["with-bounds"].classList.remove("u-hidden");

		this.nextResultId += 1;
	}

	setupEventListeners() {
		$('.js-search-select2').on('select2:select', (e) => {
			const selectedElem = document.querySelector('.js-result');
			const feature = JSON.parse(selectedElem.dataset.feature);
			$('.js-search-select2').val(null).trigger('change');
			this.addSearchResult(feature, true);
		});

		document.addEventListener('search-init', async e => {
			this.refs["search-results"].querySelectorAll('[ref="delete-button"]').forEach(button => {
				button.click();
			});

			if (e.detail.showBounds != this.refs["with-bounds-checkbox"].checked) {
				this.refs["with-bounds-toggle"].click();
			}
		});

		document.addEventListener('search-result-load', async e => {
			const KOD_OBEC = e.detail.KOD_OBEC;
			const KOD_COB = e.detail.KOD_COB;

			const formData = new FormData();
			formData.append('KOD_OBEC', KOD_OBEC);
			formData.append('KOD_COB', KOD_COB);

			const response = await fetch(urls.select2obceUrl, {
				method: 'POST',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: formData,
			});

			const json = await response.json();

			const id = `search-result-${this.nextResultId}`;
			MarkerIconStyleProvider.setColor(id, e.detail.color);

			this.addSearchResult(json.results[0].feature, false);
		});

		//$('.js-search-select2').on('select2:clear', (e) => {});

		document.addEventListener(eventNames.CHANGE_CUSTOM_MARKER_COLOR, (e) => {
			const div = this.refs["search-results"].querySelector(`#${e.detail.id}`);

			if (div) {
				div.querySelector('.js-marker-icon-color').style.color = e.detail.color;
			}
		});

		this.refs["with-bounds-toggle"].addEventListener("click", () => {
			const checkbox = this.refs["with-bounds-checkbox"];
			checkbox.checked = !checkbox.checked;
			this.dispatchCustomEvent(eventNames.SEARCH_WITH_BOUNDS_CHANGE, document, false, { checked: checkbox.checked });
		});
	}

	render() {
		return `
        <div class="layerPanel__block">
            <span class="layerPanel__heading">${uiStrings.SEARCH_HEADING}</span>
            <div ref="search" class="search active">
                <select class="js-search-select2" name="obec"></select>
            </div>
            <div class="layerPanel__control js-search-results" ref="search-results"></div>
            <div ref="with-bounds" class="u-hidden">
                <div class="search__display-bounds">
                    <div class="layerPanel__loader-container">
                        <input
                            ref="with-bounds-checkbox"
                            type="checkbox"
                            class="u-hidden js-search-with-bounds-checkbox"
                        >
                        <span ref="with-bounds-toggle" class="layerPanel__checkbox--custom"></span>
                    </div>
                    <span>zobraziť obrys územia</span>
                </div>
            </div>
        </div>`;
	}
}

export default SearchButton;
